<template>
  <label class="relative block w-full max-w-md">
    <Icon
      type="search"
      width="16"
      class="pointer-events-none absolute start-3 top-1/2 z-10 size-4 -translate-y-1/2 text-zinc-500 dark:text-zinc-300"
    />

    <input
      dusk="search-input"
      class="panel-glass-input h-11 w-full rounded-full py-2 ps-10 pe-4 text-sm"
      :placeholder="__('Search')"
      type="search"
      :value="keyword"
      spellcheck="false"
      :aria-label="__('Search')"
      @input="handleChange"
    />
  </label>
</template>

<script>
export default {
  emits: ['update:keyword'],

  props: {
    keyword: {
      type: String,
    },
  },

  methods: {
    handleChange(event) {
      this.$emit('update:keyword', event?.target?.value || '')
    },
  },
}
</script>
